export enum ScanLabelArchetype {
  NONE = "",
  DECEASED = "Deceased",
  NON_READER = "Non-Reader",
  NO_TAG = "No Tag",
}

export const SubTextByScanLabelArchetype: Record<ScanLabelArchetype, string> = {
  [ScanLabelArchetype.NONE]: "",
  [ScanLabelArchetype.DECEASED]:
    "This animal died after arriving at the saleyard. The tag should be updated to Deceased on the NLIS database.",
  [ScanLabelArchetype.NO_TAG]:
    "This animal had no EID and a post-breeder tag has been applied. Charges may be applied in accordance with the saleyard fee schedule.",
  [ScanLabelArchetype.NON_READER]:
    "This animal had a faulty EID and a post-breeder tag has been applied. Link the tags in the NLIS to preserve lifetime traceability. Charges may be applied in accordance with the saleyard fee schedule.",
};
